import { render, staticRenderFns } from "./RequestGeneralTab.vue?vue&type=template&id=28699aaa&scoped=true"
import script from "./RequestGeneralTab.vue?vue&type=script&lang=js"
export * from "./RequestGeneralTab.vue?vue&type=script&lang=js"
import style0 from "./RequestGeneralTab.vue?vue&type=style&index=0&id=28699aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28699aaa",
  null
  
)

export default component.exports